/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Comparison operator for alert thresholds
 */
export enum ThresholdOperator {

    Gt = 'gt',

    Gte = 'gte',

    Lt = 'lt',

    Lte = 'lte',

    Eq = 'eq'
}
